const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @actions
const accessKeyChangeActions = require('actions/accessKeyChange');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @components
const AccessKeyChange = require('components/myProfile/accessKeyChange/accessKeyChange');
const AccessKeyChangeSuccessStep = require('components/myProfile/accessKeyChangeSteps/accessKeyChangeSuccessStep/accessKeyChangeSuccessStep');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
// @ constants
const { FAQ_URL } = require('constants/links');
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');

class MyProfilePasswordChange extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        this.props.reset();
        this.props.requestAccessKeyData();
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.requestAccessKeyData();
    }

    buildSuccessful() {
        return (
            <div className="row grid-view--content-position-negative">
                <div className="col-xs-12 col-md-offset-2 col-md-8">
                    <AccessKeyChangeSuccessStep />
                </div>
            </div>
        );
    }

    buildWizard() {
        const {
            immAccessKeyChange,
            immProfile,
            validateStep,
            setField,
            setVisibleStep,
            setWillCancel
        } = this.props;
        const boxBody = ['profileKeys-boxBody1', 'profileKeys-boxBody2'];

        return (
            <div className="row grid-view--content-position-negative">
                <div className="col-xs-12 col-md-8">
                    <div className="row">
                        <div className="col-md-12">
                            <AccessKeyChange
                                immAccessKeyChange={immAccessKeyChange}
                                immProfile={immProfile}
                                onCancel={this.handleCancel}
                                onFinish={this.handleFinish}
                                setField={setField}
                                setVisibleStep={setVisibleStep}
                                setWillCancel={setWillCancel}
                                validateStep={validateStep}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-12 grid-view--variable-cell-separation">
                            <ContactInfoBox
                                boxTitle={formatText('profileKeys-boxTitle')}
                                boxBody={boxBody}
                                linkText1={formatText("profileKeysLanding-sideText1")}
                                linkText2={formatText("profileKeysLanding-sideText2")}
                                linkURL={FAQ_URL}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleCancel() {
        const redirectUrl = __CONTACT_CENTER__ ? '/myprofile' : '/myprofile/keys';
        this.props.history.push(redirectUrl);
    }

    handleFinish() {
        this.props.postChange();
    }

    render() {
        const mappingBreadcrumb = [
            ...(!__CONTACT_CENTER__ ? [
                {
                    text: formatText('profileKeysLanding-title'),
                    url: '/myprofile/keys'
                }
            ] : []),
            {
                text: formatText('profileKeys-titleBreadcrumb'),
                url: ''
            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-profileChangePasswordTitle')}
            />
        );

        let content;

        if (this.props.immAccessKeyChange.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizard();
        }

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle('profileKeys-titleHeader')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        {content}
                    </div>
                </div>
            </div>
        );
    }
}

MyProfilePasswordChange.propTypes = {
    history: PropTypes.object.isRequired,
    immAccessKeyChange: PropTypes.object,
    immProfile: PropTypes.object,
    postChange: PropTypes.func.isRequired,
    requestAccessKeyData: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    setField: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
};

module.exports.constructor = MyProfilePasswordChange;
module.exports.MyProfilePasswordChange = connect(
    state => ({
        immAccessKeyChange: state.accessKeyChange,
        immProfile: state.profile
    }),
    {
        postChange: accessKeyChangeActions.postChange,
        reset: accessKeyChangeActions.reset,
        requestAccessKeyData: accessKeyChangeActions.requestAccessKeyData,
        setField: accessKeyChangeActions.setField,
        setVisibleStep: accessKeyChangeActions.setVisibleStep,
        setWillCancel: accessKeyChangeActions.setWillCancel,
        validateStep: accessKeyChangeActions.validateStep
    }
)(withRouter(MyProfilePasswordChange));
